import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "countryField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selectedRadio = this.radioTargets.find(r => r.checked)
    const isLocal = selectedRadio && selectedRadio.value === "local"

    if (isLocal) {
      this.countryFieldTarget.classList.remove("hidden")
      this.countryFieldTarget.classList.add("flex") 
    } else {
      this.countryFieldTarget.classList.add("hidden")
      this.countryFieldTarget.classList.remove("flex")
    }
  }
}